// Validação de CPF e CNPJ pelos dígitos verificadores (módulo 11).
// Aceita o documento com ou sem máscara.

const somenteDigitos = (valor) => String(valor ?? '').replace(/\D/g, '');

// Todos os dígitos iguais passam no cálculo, mas não são documentos válidos.
const repetido = (digitos) => /^(\d)\1*$/.test(digitos);

/** Dígito verificador: soma ponderada pelos `pesos`, resto da divisão por 11. */
function digitoVerificador(digitos, pesos) {
  const soma = pesos.reduce((total, peso, i) => total + Number(digitos[i]) * peso, 0);
  const resto = soma % 11;
  return resto < 2 ? 0 : 11 - resto;
}

const PESOS_CPF_1 = [10, 9, 8, 7, 6, 5, 4, 3, 2];
const PESOS_CPF_2 = [11, 10, 9, 8, 7, 6, 5, 4, 3, 2];
const PESOS_CNPJ_1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const PESOS_CNPJ_2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

export function CpfValido(cpf) {
  const d = somenteDigitos(cpf);
  if (d.length !== 11 || repetido(d)) return false;
  return digitoVerificador(d, PESOS_CPF_1) === Number(d[9]) && digitoVerificador(d, PESOS_CPF_2) === Number(d[10]);
}

export function CnpjValido(cnpj) {
  const d = somenteDigitos(cnpj);
  if (d.length !== 14) return false;
  return digitoVerificador(d, PESOS_CNPJ_1) === Number(d[12]) && digitoVerificador(d, PESOS_CNPJ_2) === Number(d[13]);
}
